import React, { useEffect, useState } from 'react'
import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, FormControl, IconButton, Stack, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../global/config/store';
import useDebounce from '../CreateAllocations/UseDebounce.tsx';
import { ApiGetClientEntityByClientGroupId, ApiGetRestrictVenues, ApiGetShopperList, ApiGetVenueList, ApiAddRestrictVenue, ApiRemoveRestrictVenues, ApiUpdateRestrictRemark } from '../../../apiService/Core/Apicall.tsx';
import { toast } from 'react-toastify';
import { setSelectedClientGroup } from '../../../global/config/Reducer/clientSlice.ts';
import { CancelOutlined, Edit } from '@mui/icons-material';
import dayjs from 'dayjs';

function RestrictScreen() {
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const dispatch = useDispatch()
    const [venueName, setVenueName] = useState([]);
    const [venueNameValue, setVenueNameValue] = useState<any>(null);
    const [filtervenueNameValue, setFilterVenueNameValue] = useState<any>(null);
    const [clientEntityList, setClientEntityList] = useState<any>([]);
    const [clientEntityId, setClientEntityId] = useState<string | null>(null);
    const [filterclientEntityId, setFilterClientEntityId] = useState<string | null>(null);
    const Clientlist = useSelector((state: RootState) => state.client.clientList);
    const [selectedClient, setSelectedClient] = useState<any>(selectedClientName);
    const [ClientId, setClientId] = useState(null);
    const [shopperlist, setshopperlist] = useState([]);
    const [selectedShopper, setSelectedShopper] = useState<any>(null);
    const [searchShopper, setsearchShopper] = useState<any>("");
    const [selectedShopper2, setSelectedShopper2] = useState<any>(null);
    const [searchShopper2, setsearchShopper2] = useState<any>("");
    const debouncedClientEntityId = useDebounce(clientEntityId, 500);
    const [venue, setVenue] = useState([]);
    const [restrictData, setRestrictData] = useState<any>([]);
    const [openAdd, setOpenAdd] = useState<boolean>(false)
    const [openDelete, setOpenDelete] = useState<boolean>(false)
    const [remarkreason, setRemarkreason] = useState("")
    const [selectedUser, setSelectedUser] = useState<any>()
    const [datalength, setdatalength] = useState<any>(null);
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(50)
    const [selectedRestrictId, setSelectedRestrictId] = useState<any>(null)


    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(Number.parseInt(event.target.value, 10))
        setPage(0)
    }



    useEffect(() => {
        if (Clientlist.length > 2) {
            // setSelectedClient(Clientlist[2]);
            setClientId(Clientlist[2].clientGroupName);
        }
    }, [Clientlist]);

    useEffect(() => {
        if (clientEntityId === null && filterclientEntityId === null) {
            setVenueName([])
        }
    }, [clientEntityId])

    useEffect(() => {
        setSelectedClient(selectedClientName)
    }, [selectedClientName])

    useEffect(() => {
        if (selectedClient?.clientGroupName) {
            handleGetClientList()
        }
    }, [selectedClient?.clientGroupName])

    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`
        if (!selectedClient?.clientGroupName) return
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            console.log(res.data)
            setClientEntityList(res.data)
            // setClientEntityId(res.data[0].clientEntityId)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }
    const ApiCallGetVenueList = async (debouncedClientEntityId?: any) => {
        let data = `?offset=0&limit=500`
        if (clientEntityId || filterclientEntityId) {
            data += `&clientEntityId=${clientEntityId || filterclientEntityId}&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
        } else if (selectedClient?.clientGroupName) {
            data += `&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
        }
        const res = await ApiGetVenueList(data)
        setVenue(res?.data)
        const response = res?.data.map((item) => ({
            label: item.venueName,
            value: item.venueId,
            state: item.state,
            entityTypeName: item.entityTypeName
        }))
        setVenueName(response)
        // setVenueNameValue(response[0]?.value);
    }
    useEffect(() => {
        if (debouncedClientEntityId || filterclientEntityId || selectedClient?.clientGroupName) {
            ApiCallGetVenueList(debouncedClientEntityId)
        } else {
            setVenueName([])
            setVenueNameValue(null)
        }
    }, [debouncedClientEntityId, filterclientEntityId, selectedClient?.clientGroupName])
    const getShopperList = async (text) => {
        setshopperlist([])
        try {
            const data = `?offset=0&limit=1000${text?.length > 0 ? `&search=${text}` : ''}`
            const res = await ApiGetShopperList(data)
            const originonal = res.data
            setshopperlist(originonal)
        } catch (error) {
            alert(error)
        }
    }
    useEffect(() => {
        getShopperList(searchShopper);
    }, [searchShopper])
    useEffect(() => {
        getShopperList(searchShopper2);
    }, [searchShopper2])

    const RestrictData = async () => {
        const data = `?offset=${page * rowsPerPage}&limit=${rowsPerPage}&clientGroupName=${selectedClient?.clientGroupName}${filterclientEntityId ? `&clientEntityId=${filterclientEntityId}` : ""}${filtervenueNameValue ? `&venueId=${filtervenueNameValue}` : ""}${selectedShopper2 ? `&userId=${selectedShopper2?.userId}`:""}`
        const res = await ApiGetRestrictVenues(data);
        setdatalength(res.totalCount)
        setRestrictData(res?.data);
    }

    useEffect(() => {
        RestrictData()
    }, [filterclientEntityId, selectedClient, filtervenueNameValue, rowsPerPage, page, selectedShopper2])

    const handleAdd = async () => {
        if (!selectedShopper || (!clientEntityId && !venueNameValue)) {
            toast.info("Please select a Venue or a Business and a shopper");
            return;
        }
        if (!remarkreason?.trim()) {
            toast.info("Remark is required")
            return;
        }

        try {
            const payload = {
                userId: selectedShopper.userId,
                venueId: venueNameValue,
                clientEntityId: clientEntityId,
                remarks: remarkreason

            };

            const response = await ApiAddRestrictVenue(payload);
            if (response?.status || response?.success) {
                toast.success(response?.message);
                RestrictData();
                setSelectedShopper(null);
                setClientEntityId(null);
                setVenueNameValue(null);
                setOpenAdd(false)
                setRemarkreason("")
            }
            else if (!response?.status) {
                toast.error(response?.message)
            }
            // setsearchShopper("");
        } catch (error) {
            console.error("Error adding restriction:", error);
            toast.error("Error adding restriction: " + (error.response?.data?.message || error.message));
        }
    };
    const handleDelete = async () => {
        if (!remarkreason?.trim()) {
            toast.info("Remark is required")
            return;
        }
        if (!window.confirm("Are you sure you want to remove this restriction?")) {
            return;
        }
        try {
            const data = {
                userId: selectedUser?.userId,
                venueId: selectedUser?.venueId,
                unrestrictRemarks: remarkreason
            }
            const response = await ApiRemoveRestrictVenues(data);
            if (response?.success || response?.status) {
                setSelectedUser("")
                setOpenDelete(false)
                setRemarkreason("")
            }
            toast.success(response?.message || "Restriction removed successfully");
            RestrictData();
        } catch (error) {
            console.error("Error removing restriction:", error);
            toast.error("Error removing restriction: " + (error.response?.data?.message || error.message));
        }
    };

    const handleUpdateRemark = async () => {
        if (!remarkreason?.trim()) {
            toast.info("Remark is required")
            return;
        }
        try {
            const data = {
                shopperVenueRestrictionId: selectedRestrictId?.shopperVenueRestrictionId,
                remarks: remarkreason
            }
            const response = await ApiUpdateRestrictRemark(data);
            if (response?.success || response?.status) {
                setSelectedRestrictId(null)
                setRemarkreason("")
            }
            toast.success(response?.message || "Restriction Remark Update successfully");
            RestrictData();
        } catch (error:any) {
            console.error("Error removing restriction:", error);
            toast.error("Error removing restriction: " + (error.response?.data?.message || error.message));
        }
    };

    return (
        <Box sx={{ p: 4 }} style={{ background: "white" }}>
            <Stack spacing={3}>
                <Box sx={{ width: "100%" }}>
                    <h1 className="common-manage-h1 mt-0 col-6" style={{ textAlign: "end", marginLeft: "180px" }}>
                        Restrict Access
                    </h1>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            alignItems: "flex-start",
                            justifyContent: 'space-between',
                            gap: 3,
                            mt: 3,
                            width: "100%",
                            flexWrap: "wrap"
                        }}
                    >
                        {/* Client */}
                        <Box className='d-flex' gap={2}>
                            <FormControl size="small" sx={{ flex: 1, minWidth: 220, maxWidth: 370 }}>
                                <Autocomplete
                                    disablePortal
                                    id="client-autocomplete"
                                    options={Clientlist}
                                    value={selectedClient}
                                    getOptionLabel={(option: any) => option?.clientGroupName}
                                    isOptionEqualToValue={(option: any, value: any) =>
                                        option.clientGroupDBName === value.clientGroupDBName
                                    }
                                    onChange={(event, newValue: any) => {
                                        dispatch(setSelectedClientGroup(newValue));
                                        setClientId(newValue?.clientGroupName || null);
                                        setClientEntityId(null);
                                        setVenueNameValue(null);
                                        setClientEntityList([]);
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Select Client" />}
                                    size="small"
                                />
                            </FormControl>

                            <FormControl size="small" sx={{ flex: 1, minWidth: 220, maxWidth: 370 }}>
                                <Autocomplete
                                    disablePortal
                                    id="business-filter-autocomplete"
                                    options={clientEntityList?.filter((item) => item.clientEntityId !== null)}
                                    getOptionLabel={(option) => option?.entityName || ""}
                                    onChange={(event, newValue: any) => {
                                        setFilterClientEntityId(newValue?.clientEntityId || null);
                                        if (!newValue) setFilterVenueNameValue(null);
                                    }}
                                    value={clientEntityList?.find((o) => o?.clientEntityId === filterclientEntityId) || null}
                                    renderInput={(params) => <TextField {...params} label="Select Business" />}
                                    size="small"
                                />
                            </FormControl>

                            <FormControl size="small" sx={{ flex: 1, minWidth: 220, maxWidth: 370 }}>
                                <Autocomplete
                                    disablePortal
                                    id="venue-filter-autocomplete"
                                    options={venueName}
                                    getOptionLabel={(option: any) => `${option?.label} (${option?.state}) (${option?.entityTypeName})`}
                                    value={venueName.find((o: any) => o.value === filtervenueNameValue) || null}
                                    onChange={(event, newValue: any) => setFilterVenueNameValue(newValue?.value)}
                                    renderInput={(params) => <TextField {...params} label="Select Site" />}
                                    size="small"
                                />
                            </FormControl>
                            <FormControl size="small" sx={{ flex: 1, minWidth: 400, maxWidth: 450 }}>
                                <Autocomplete
                                    id="shopper-autocomplete"
                                    disablePortal
                                    options={shopperlist?.filter((item: any) => item?.firstName !== "")}
                                    value={selectedShopper2}
                                    inputValue={searchShopper2 || ""}
                                    onInputChange={(event, newInputValue) => {
                                        setsearchShopper2(newInputValue);
                                        if (newInputValue === "") setSelectedShopper2(null);
                                    }}
                                    getOptionLabel={(option: any) =>
                                        `${option?.firstName} ${option.lastName} (${option?.userName}) (${option?.emailId}) (${option?.contactNo})`
                                    }
                                    isOptionEqualToValue={(option: any, value: any) =>
                                        option.userId === value.userId || option.emailId === value.emailId
                                    }
                                    onChange={(event, newValue: any) => setSelectedShopper2(newValue)}
                                    renderInput={(params) => <TextField {...params} label="Select Shopper" />}
                                    size="small"
                                />
                            </FormControl>  
                        </Box>

                        {/* Shopper */}

                        {/* Add Button */}
                        <Button
                            variant="contained"
                            className="table-row-background"
                            onClick={() => setOpenAdd(true)}
                            sx={{
                                minWidth: 100,
                                height: 40,
                                alignSelf: { xs: "stretch", md: "center" },
                            }}
                        >
                            Add
                        </Button>
                    </Box>

                </Box>
            </Stack>
            <Box sx={{ width: '100%', overflow:'auto', marginTop: 5 }}>
                <Table >
                    <TableHead sx={{ bgcolor: "#7a7d52" }}>
                        <TableRow>
                            <TableCell align="center" sx={{ color: "white" }}>Business Name</TableCell>
                            <TableCell align="center" sx={{ color: "white" }}>Site Name</TableCell>
                            <TableCell align="center" sx={{ color: "white" }}>Shopper</TableCell>
                            <TableCell align="center" sx={{ color: "white" }}>Remark</TableCell>
                            <TableCell align="center" sx={{ color: "white" }}>Added By</TableCell>
                            <TableCell align="center" sx={{ color: "white" }}>Added At</TableCell>
                            <TableCell sx={{ color: "white" }}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {restrictData.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell align="center">{row.clientEntityName}</TableCell>
                                <TableCell align="center">{row.venueName}</TableCell>
                                <TableCell align="center">{row.userName}</TableCell>
                                <TableCell align="center">
                                    {row.remarks}
                                    <Tooltip title='change remrak'>
                                    <IconButton onClick={()=>{setSelectedRestrictId(row)}}><Edit className='fs-16' /></IconButton>
                                    </Tooltip>
                                    </TableCell>
                                <TableCell align="center">{row?.blockedBy?.userName}</TableCell>
                                <TableCell align="center">{dayjs(row?.blockedOn).format("DD/MM/YYYY")}</TableCell>
                                <TableCell sx={{ width: '80px', paddingLeft: '8px' }}>
                                    <Button variant="contained" className="table-row-background" onClick={() => { setSelectedUser(row); setOpenDelete(true) }}>
                                        Delete
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        component="div"
                        count={datalength}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
            </Box>
            <Dialog open={openAdd}>
                <DialogContent className="dialog-content">
                    <Box className='d-flex mb-4 align-items-center justify-content-between'>
                        <Typography variant='h5'>Restrict Access</Typography>
                        <IconButton className='m-0 p-0' onClick={() => { setSelectedShopper(null); setClientEntityId(null); setVenueNameValue(null); setOpenAdd(false) }}><CancelOutlined /></IconButton>
                    </Box>
                    <FormControl size="small" fullWidth>
                        <Autocomplete
                            disablePortal
                            className='mb-3'
                            id="client-autocomplete"
                            options={Clientlist}
                            value={selectedClient}
                            getOptionLabel={(option: any) => option?.clientGroupName}
                            isOptionEqualToValue={(option: any, value: any) =>
                                option.clientGroupDBName === value.clientGroupDBName
                            }
                            onChange={(event, newValue: any) => {
                                dispatch(setSelectedClientGroup(newValue));
                                setClientId(newValue?.clientGroupName || null);
                                setClientEntityId(null);
                                setVenueNameValue(null);
                                setClientEntityList([]);
                            }}
                            renderInput={(params) => <TextField {...params} label="Select Client" />}
                            size="small"
                        />
                    </FormControl>

                    <FormControl size="small" fullWidth>
                        <Autocomplete
                            className='mb-3'
                            // disablePortal
                            id="business-autocomplete"
                            options={clientEntityList?.filter((item) => item.clientEntityId !== null)}
                            getOptionLabel={(option) => option?.entityName || ""}
                            onChange={(event, newValue: any) => {
                                setClientEntityId(newValue?.clientEntityId || null);
                                if (!newValue) setVenueNameValue(null);
                            }}
                            value={clientEntityList?.find((o) => o?.clientEntityId === clientEntityId) || null}
                            renderInput={(params) => <TextField {...params} label="Select Business" />}
                            size="small"
                        />
                    </FormControl>

                    {/* Venue */}
                    <FormControl size="small" fullWidth>
                        <Autocomplete
                            // disablePortal
                            className='mb-3'
                            id="venue-autocomplete"
                            options={venueName}
                            getOptionLabel={(option: any) => `${option?.label} (${option?.state}) (${option?.entityTypeName})`}
                            value={venueName.find((o: any) => o.value === venueNameValue) || null}
                            onChange={(event, newValue: any) => setVenueNameValue(newValue?.value)}
                            renderInput={(params) => <TextField {...params} label="Select Site" />}
                            size="small"
                        />
                    </FormControl>

                    {/* Shopper */}
                    <FormControl size="small" fullWidth>
                        <Autocomplete
                            id="shopper-autocomplete"
                            // disablePortal
                            options={shopperlist?.filter((item: any) => item?.firstName !== "")}
                            value={selectedShopper}
                            inputValue={searchShopper || ""}
                            onInputChange={(event, newInputValue) => {
                                setsearchShopper(newInputValue);
                                if (newInputValue === "") setSelectedShopper(null);
                            }}
                            getOptionLabel={(option: any) =>
                                `${option?.firstName} ${option.lastName} (${option?.userName}) (${option?.emailId}) (${option?.contactNo})`
                            }
                            isOptionEqualToValue={(option: any, value: any) =>
                                option.userId === value.userId || option.emailId === value.emailId
                            }
                            onChange={(event, newValue: any) => setSelectedShopper(newValue)}
                            renderInput={(params) => <TextField {...params} label="Select Shopper" />}
                            size="small"
                        />
                    </FormControl>
                    <FormControl size="small" className='mt-3' fullWidth>
                        <TextField
                            className="mb-3"
                            label="Remark / Reason"
                            value={remarkreason}
                            onChange={(e) => setRemarkreason(e.target.value)}
                            size="small"
                            fullWidth
                            multiline
                            rows={3}
                        />
                    </FormControl>
                </DialogContent>
                <DialogActions className='d-flex justify-content-center'>
                    <Button
                        variant="contained"
                        className="table-row-background"
                        onClick={() => handleAdd()}
                        sx={{
                            minWidth: 100,
                            height: 40,
                            alignSelf: { xs: "stretch", md: "center" },
                        }}
                    >
                        ADD
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openDelete}>
                <DialogContent className="dialog-content pb-0">
                    <Box className='d-flex mb-4 align-items-center justify-content-between'>
                        <Typography variant='h5'>Delete Restrict Access</Typography>
                        <IconButton className='m-0 p-0' onClick={() => { setSelectedUser(null); setRemarkreason(''); setOpenDelete(false) }}><CancelOutlined /></IconButton>
                    </Box>
                    <FormControl size="small" className='mt-3' sx={{ minWidth: '400px' }} fullWidth>
                        <TextField
                            className="mb-3"
                            label="Remark / Reason"
                            value={remarkreason}
                            onChange={(e) => setRemarkreason(e.target.value)}
                            size="small"
                            fullWidth
                            multiline
                            rows={3}
                        />
                    </FormControl>
                </DialogContent>
                <DialogActions className='d-flex justify-content-center'>
                    <Button
                        variant="contained"
                        className="table-row-background"
                        onClick={() => handleDelete()}
                        sx={{
                            minWidth: 100,
                            height: 40,
                            alignSelf: { xs: "stretch", md: "center" },
                        }}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={selectedRestrictId}>
                <DialogContent className="dialog-content pb-0">
                    <Box className='d-flex mb-4 align-items-center justify-content-between'>
                        <Typography variant='h5'>Update Remark</Typography>
                        <IconButton className='m-0 p-0' onClick={() => { setSelectedRestrictId(null); setRemarkreason('')}}><CancelOutlined /></IconButton>
                    </Box>
                    <FormControl size="small" className='mt-3' sx={{ minWidth: '400px' }} fullWidth>
                        <TextField
                            className="mb-3"
                            label="Remark / Reason"
                            value={remarkreason}
                            onChange={(e) => setRemarkreason(e.target.value)}
                            size="small"
                            fullWidth
                            multiline
                            rows={3}
                        />
                    </FormControl>
                </DialogContent>
                <DialogActions className='d-flex justify-content-center'>
                    <Button
                        variant="contained"
                        className="table-row-background"
                        onClick={() => handleUpdateRemark()}
                        sx={{
                            minWidth: 100,
                            height: 40,
                            alignSelf: { xs: "stretch", md: "center" },
                        }}
                    >
                        Update
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>
    )
}
export default RestrictScreen;